import { apiClient } from '@/shared/lib/apiClient';
import type { ApiSuccessResponse } from '@super-admin/shared-types';
import type { PortalPricingCatalog } from '../types/portalPricingCatalog';

export async function fetchPortalPricingCatalog(): Promise<PortalPricingCatalog> {
  const response = await apiClient.get<ApiSuccessResponse<PortalPricingCatalog>>(
    '/api/v1/customer/subscription/pricing-catalog',
  );

  return response.data;
}
